export default "__VITE_ASSET__DvPFh1HJ__"